<template>
  <el-card shadow="false" :body-style="{ padding: 0 }">
    <table-view
      table-card-title="D&B LOOKUP"
      :table-model="tableModel"
      :show-page="false"
      :table-data="tableData"
    >
      <template v-slot:radio="{ tableRow }">
        <el-radio v-model="radio" :label="tableRow.row.dunsNumber">
          &nbsp;
        </el-radio>
      </template>
    </table-view>
    <customize-button
      type="primary"
      style="margin: 0 0 20px 20px"
      @click="handleSubmit"
    >
      Submit
    </customize-button>
  </el-card>
</template>

<script>
import { getGlobalDetail } from '../api'

export default {
  data() {
    const tableModel = [
      {
        width: 30,
        label: '',
        slotName: 'radio',
      },
      {
        width: 130,
        label: 'Duns Number',
        prop: 'dunsNumber',
      },
      {
        width: 170,
        label: 'Registration Number',
        prop: 'registrationNumber',
      },
      {
        width: 220,
        label: 'Type Description',
        prop: 'typeDescription',
      },
      {
        width: 220,
        label: 'Business Name',
        prop: 'businessName',
      },
      {
        width: 260,
        label: 'Address',
        prop: 'address',
      },
      {
        width: 140,
        label: 'City',
        prop: 'city',
      },
      {
        width: 200,
        label: 'State/Province/Region',
        prop: 'state',
      },
      {
        width: 120,
        label: 'Country Code',
        prop: 'countryCode',
      },
      {
        width: 120,
        label: 'Postal Code',
        prop: 'postalCode',
      },
      {
        width: 120,
        label: 'Telephone #',
        prop: 'telephone',
      },
      {
        width: 120,
        label: 'URL',
        prop: 'url',
      },
      {
        width: 130,
        label: 'Confidence Code',
        prop: 'confidenceCode',
      },
      {
        width: 120,
        label: 'Match Grade',
        prop: 'matchGrade',
      },
      {
        width: 120,
        label: 'Trade Style',
        prop: 'tradeStyle',
      },
      {
        width: 130,
        label: 'Operating Status',
        prop: 'operatingStatus',
      },
      {
        width: 120,
        label: 'isStandalone',
        prop: 'isStandalone',
      },
    ]
    return {
      tableData: [],
      tableModel,
      radio: '',
    }
  },
  mounted() {
    this._getGlobalDetail()
  },
  methods: {
    handleSubmit() {
      if (this.radio) {
        this.$router.push({
          name: 'bureau-report-add',
          params: { customerId: this.$route.params.customerId },
          query: {
            dunsNumber: this.radio,
          },
        })
      } else {
        this.$message.warning('Please select')
      }
    },
    async _getGlobalDetail() {
      try {
        const { id } = this.$store.state.bureauReportBasicInfo
        this.tableData = await getGlobalDetail(id)
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>
